import React, { Fragment, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAddAddressMutation } from '../../../redux/APIs/addressApi';

function AddNewAdrsForm(props) {
  const dispatch = useDispatch();
  const { initialData } = props;
  const [open, setOpen] = React.useState(false);
  const [addAddress] = useAddAddressMutation();
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  // const handleCheckboxChange = (event) => {
  //   const { checked } = event.target;
  //   setIsDefault(checked);
  // };
  const [name, setName] = useState(initialData ? initialData.name : "");
  const [mobileNumber, setMobileNumber] = useState(
    initialData ? initialData.mobileNumber : ""
  );
  const [pinCode, setPinCode] = useState(
    initialData ? initialData.pinCode : ""
  );
  const [locality, setLocality] = useState(
    initialData ? initialData.locality : ""
  );
  const [addressFull, setAddressFull] = useState(
    initialData ? initialData.addressFull : ""
  );
  const [cityDistrict, setCityDistrict] = useState(
    initialData ? initialData.cityDistrictTown : ""
  );
  const [state, setState] = useState(initialData ? initialData.state : "");
  const [country, setCountry] = useState(initialData ? initialData.state : "");
  const [landmark, setLandmark] = useState(
    initialData ? initialData.landmark : ""
  );
  const [alternatePhone, setAlternatePhone] = useState(
    initialData ? initialData.alternatePhone : ""
  );
  const [addressType, setAddressType] = useState(
    initialData ? initialData.addressType : ""
  );
  const [isDefault, setIsDefault] = useState(false);

  const [submitFlag, setSubmitFlag] = useState(false);
  const [id, setId] = useState(initialData ? initialData._id : "");

  function handleCheckboxChange(event) {
    setIsDefault(event.target.checked);
  }

  console.log(isDefault);

  const onAdrsFormSubmit = async(e) => {
    e.preventDefault();
    const payload = {
      address: {
        name,
        mobileNumber,
        pinCode,
        locality,
        addressFull,
        cityDistrict,
        state,
        country,
        isDefault,
        landmark,
        alternatePhone,
        addressType,
      },
    };
    console.log(payload);
    if (id) {
      payload.address._id = id;
    }
    const response = await addAddress(payload);
    console.log('response', response)
    // dispatch(addNewAddress(payload));
    setSubmitFlag(true);
  };
  // useEffect(() => {
  //   console.log("addressCount", addressFull);
  //   if (submitFlag) {
  //     console.log("where are we");
  //     let _address = {};
  //     if (id) {
  //       _address = {
  //         _id: id,
  //         name,
  //         mobileNumber,
  //         pinCode,
  //         locality,
  //         addressFull,
  //         cityDistrict,
  //         state,
  //         landmark,
  //         alternatePhone,
  //         addressType,
  //       };
  //     } else {
  //       _address = addressFull.slice(addressFull.length - 1)[0];
  //     }
  //     props.onSubmitForm(_address);
  //   }
  // }, [addressFull]);
  
  return (
    <Fragment>
      <div className="w-[100dvw] bg-white shadow-lg rounded-lg p-6 mt-8">
  <h2 className="text-xl font-semibold text-gray-800 mb-4">Address Details</h2>
  <form className="space-y-4">
    {/* Receiver Name */}
    <div className="relative">
      <input
        type="text"
        required
        autoComplete="off"
        name="Receiver Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        className="h-12 w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-400"
        placeholder=" "
      />
      <label className="absolute left-4 top-2 text-sm text-gray-500 transform -translate-y-4 scale-75 origin-top-left transition-all peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-2 peer-placeholder-shown:text-gray-400 bg-white px-2 rounded-full">
        Name
      </label>
    </div>

    {/* Mobile Number */}
    <div className="relative">
      <input
        type="number"
        required
        maxLength={10}
        autoComplete="off"
        name="Mobile Number"
        onWheel={(e) => e.target.blur()}
        value={mobileNumber}
        onChange={(e) => setMobileNumber(e.target.value)}
        className="h-12 w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-400"
        placeholder=" "
      />
      <label className="absolute left-4 top-2 text-sm text-gray-500 transform -translate-y-4 scale-75 origin-top-left transition-all peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-2 peer-placeholder-shown:text-gray-400 bg-white px-2 rounded-full">
        Mobile Number
      </label>
    </div>

    {/* Pincode */}
    <div className="relative">
      <input
        type="number"
        required
        maxLength={6}
        autoComplete="off"
        name="Pincode"
        onWheel={(e) => e.target.blur()}
        value={pinCode}
        onChange={(e) => setPinCode(e.target.value)}
        className="h-12 w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-400"
        placeholder=" "
      />
      <label className="absolute left-4 top-2 text-sm text-gray-500 transform -translate-y-4 scale-75 origin-top-left transition-all peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-2 peer-placeholder-shown:text-gray-400 bg-white px-2 rounded-full bg-white">
        Pincode
      </label>
    </div>

    {/* Address */}
    <div className="relative">
      <input
        type="text"
        required
        autoComplete="off"
        name="Address"
        value={addressFull}
        onChange={(e) => setAddressFull(e.target.value)}
        className="h-12 w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-400"
        placeholder=" "
      />
      <label className="absolute left-4 top-2 text-sm text-gray-500 transform -translate-y-4 scale-75 origin-top-left transition-all peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-2 peer-placeholder-shown:text-gray-400 bg-white px-2 rounded-full">
        Address (Locality/Town)
      </label>
    </div>

    {/* Alternate Mobile Number */}
    <div className="relative">
      <input
        type="number"
        required
        maxLength={10}
        autoComplete="off"
        name="Alternate Mobile Number"
        value={alternatePhone}
        onChange={(e) => setAlternatePhone(e.target.value)}
        className="h-12 w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-400"
        placeholder=" "
      />
      <label className="absolute left-4 top-2 text-sm text-gray-500 transform -translate-y-4 scale-75 origin-top-left transition-all peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-2 peer-placeholder-shown:text-gray-400 bg-white px-2 rounded-full">
        Alternate Mobile Number
      </label>
    </div>

    {/* Landmark */}
    <div className="relative">
      <input
        type="text"
        required
        autoComplete="off"
        name="Landmark"
        value={landmark}
        onChange={(e) => setLandmark(e.target.value)}
        className="h-12 w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-400"
        placeholder=" "
      />
      <label className="absolute left-4 top-2 text-sm text-gray-500 transform -translate-y-4 scale-75 origin-top-left transition-all peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-2 peer-placeholder-shown:text-gray-400 bg-white px-2 rounded-full">
        Landmark
      </label>
    </div>

    {/* Address Type */}
    <div>
      <p className="text-sm font-semibold text-gray-600 mb-2">Address Type</p>
      <div className="flex space-x-4">
        <label className="flex items-center space-x-2">
          <input
            type="radio"
            name="addressType"
            value="Home"
            onClick={() => setAddressType("Home")}
            className="h-4 w-4 text-indigo-600"
          />
          <span>Home</span>
        </label>
        <label className="flex items-center space-x-2">
          <input
            type="radio"
            name="addressType"
            value="Work"
            onClick={() => setAddressType("Work")}
            className="h-4 w-4 text-indigo-600"
          />
          <span>Work</span>
        </label>
      </div>
    </div>

    {/* Set Default Address */}
    <div className="flex items-center space-x-2">
      <input
        type="checkbox"
        checked={isDefault}
        onChange={handleCheckboxChange}
        className="h-5 w-5 text-indigo-600"
      />
      <span>Set as default address</span>
    </div>

    {/* Submit Button */}
    <div className="mt-4">
      <button
        type="submit"
        onClick={onAdrsFormSubmit}
        className="h-12 w-full bg-indigo-600 text-white font-semibold py-2 rounded-lg hover:bg-indigo-700 transition"
      >
        Save Address
      </button>
    </div>
  </form>
</div>

    </Fragment>
  )
}

export default AddNewAdrsForm